var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ show: _vm.showSnackbar },style:({ backgroundColor: _vm.snackbarColor }),attrs:{"id":"snackbar"}},[_vm._v(" "+_vm._s(_vm.snackbarMessage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }